import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { AuthService } from 'app/modules/auth/services/auth.service';
import { QuotaDetail } from 'app/modules/domain/models/quotaDetails';
import { Company } from 'app/modules/domain/models/company';
import { RoleGuardService } from 'app/modules/auth/services/role.guard';
import { MdDialog } from '@angular/material';
import { EditCompanyQuotaComponent } from './components/edit-company/edit-company-quota.component';
import { User } from 'app/modules/domain/models/user';
import { Quota } from 'app/modules/domain/models/quota';

@Component({
  selector: 'app-my-organisation',
  templateUrl: './my-organisation.component.html',
  styleUrls: ['./my-organisation.component.scss']
})
export class MyOrganisationComponent implements OnInit {
  public isSuperAdmin = false;
  public errorString: string;
  public company: Company;
  public totalQuota: number;
  public allocatedQuota: number;
  public users: User[] = [];

  private companyId: string;
  public companyApiKey: string;

  constructor(private adminService: AdminService,
    private authService: AuthService,
    private roleGuardService: RoleGuardService,
    public dialog: MdDialog) { }

  ngOnInit() {
    const token = this.authService.getDecodedJwtToken();
    this.companyId = token.CompanyId;

    this.isSuperAdmin = this.roleGuardService.isAuthorized(['SuperAdmin']);

    this.getCompanyQuota(token.CompanyId);
    this.getCompany(token.CompanyId);
    this.getUsers();
  }

  private getCompany(companyId: string): void {
    this.adminService.getCurrentCompany(companyId)
      .subscribe((company: Company) => {
        this.company = company;
      });
  }

  private getCompanyQuota(companyId: string): void {
    this.adminService.getQuotaForCompany(companyId)
      .subscribe((quota: QuotaDetail) => {
        this.totalQuota = quota.totalQuota;
      });
  }

  private getUsers(): void {
    this.adminService.getUsersForCompany(this.companyId)
      .subscribe((users: User[]) => {
        this.enrichUsers(users);
      });
  }

  private enrichUsers(users: User[]): void {
    this.adminService.getQuotaForCompanyUsers(this.companyId).subscribe((quotas: Quota[]) => {
      const companyQuota = quotas.find(q => q.userId === q.companyId);

      if (companyQuota && companyQuota.limit && companyQuota.limit >= 0) {
        this.allocatedQuota = quotas.filter(q => q.userId !== q.companyId).reduce((prev, curr) => prev + curr.limit, 0);
        this.totalQuota = companyQuota.limit;
        this.companyApiKey = undefined;
      } else if (companyQuota && companyQuota.apiKey) {
        this.companyApiKey = companyQuota.apiKey;
        this.allocatedQuota = undefined;
        this.totalQuota = undefined;
      }

      this.users = users.map(u => {
        const userInfo = quotas.find(q => q.userId === u.id);

        return {
          ...u,
          limit: userInfo && userInfo.limit
        };
      });
    });
  }

  public onUpdateUsers(event) {
    this.getUsers();
  }

  public openDialog() {
    const dialogRef = this.dialog.open(EditCompanyQuotaComponent, {
      width: '450px',
      data: { quota: this.totalQuota }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.doUpdateQuota(result);
      }
    });
  }

  private doUpdateQuota(newQuota: { quota?: number; apiKey?: string }): void {
    this.adminService.setQuotaForCompany(this.company.id, newQuota)
        .subscribe((success) => {
          if (success) {
            if (newQuota.quota) {
              this.totalQuota = newQuota.quota;
              this.companyApiKey = undefined;
            } else {
              this.companyApiKey = newQuota.apiKey;
              this.allocatedQuota = undefined;
              this.totalQuota = undefined;
            }
          }
        }, (err) => {
          const errorKey = Object.keys(err.error)[0];
          this.setError(errorKey ? `UPDATE_COMPANY.${errorKey}` : 'UNKNOWN_ERROR');
        });
  }

  public setError(errorString: string): void {
    this.errorString = errorString;
    setTimeout(function () { this.dismissError(); }.bind(this), 7000);
  }

  public dismissError(): void {
    this.errorString = undefined;
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/my-organisation/my-organisation.component.ts